// stripe.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { StripeConfigInterface } from './stripe-config-interface';
import { parseResponse } from 'src/app/core/helpers';
import { AppSettingsService } from 'src/app/core/app-settings.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
    providedIn: 'root'
})
export class StripeConfigService {

    constructor(private http: HttpClient, private appSettingsService: AppSettingsService) {

    }
    createStripeConfig(data: StripeConfigInterface) {
        return this.http.post('stripe/stripe-config', data, httpOptions).pipe(
            map((resp) => {
                return parseResponse(resp);
            })
        );
    }
    deleteStripeConfig(id: any) {
        return this.http.delete('stripe/' + id, httpOptions).pipe(
            map((resp) => {
                return parseResponse(resp);
            })
        );
    }

    //handle error messages
    handleError(err: any) {
        this.appSettingsService.handleError(err);
    }
}
